
import api from "@/api";
import { LogEntry } from "@/api/dtos/LogEntry.schema";
import { LogEventType } from "@/api/dtos/LogEventType.schema";
import { StationSummary } from "@/api/dtos/StationSummary.schema";
import DetailedLog from "@/components/log/DetailedLog.vue";
import { StationsModule } from "@/store/modules/StationsModule";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    DetailedLog,
  },
})
export default class LogView extends Vue {
  openTab = null;

  stationLogEntries: LogEntry[] = [];
  userLogEntries: LogEntry[] = [];
  operatorLogEntries: LogEntry[] = [];
  adminLogEntries: LogEntry[] = [];

  mounted(): void {
    StationsModule.fetchStationSummaries();
  }

  get stations(): StationSummary[] {
    return StationsModule.stationSummaries;
  }

  async onStationTabQuery(filter: {
    dateRange: [Date, Date];
    stations: StationSummary[];
    eventTypes: LogEventType[];
  }): Promise<void> {
    this.stationLogEntries = await api.LogApi.getLog(
      filter.dateRange[0],
      filter.dateRange[1],
      this.stations.map((s) => s.uuid),
      filter.eventTypes
    );
  }

  async onUserTabQuery(filter: {
    dateRange: [Date, Date];
    stations: StationSummary[];
    eventTypes: LogEventType[];
  }): Promise<void> {
    this.userLogEntries = await api.LogApi.getLog(
      filter.dateRange[0],
      filter.dateRange[1],
      this.stations.map((s) => s.uuid),
      filter.eventTypes
    );
  }

  async onOperatorTabQuery(filter: {
    dateRange: [Date, Date];
    stations: StationSummary[];
    eventTypes: LogEventType[];
  }): Promise<void> {
    this.operatorLogEntries = await api.LogApi.getLog(
      filter.dateRange[0],
      filter.dateRange[1],
      this.stations.map((s) => s.uuid),
      filter.eventTypes
    );
  }

  async onAdminTabQuery(filter: {
    dateRange: [Date, Date];
    stations: StationSummary[];
    eventTypes: LogEventType[];
  }): Promise<void> {
    this.adminLogEntries = await api.LogApi.getLog(
      filter.dateRange[0],
      filter.dateRange[1],
      this.stations.map((s) => s.uuid),
      filter.eventTypes
    );
  }
}
